"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherContractRequest = void 0;
var OtherContractRequest = /** @class */ (function () {
    function OtherContractRequest() {
    }
    return OtherContractRequest;
}());
exports.OtherContractRequest = OtherContractRequest;
;
//# sourceMappingURL=otherContract.request.js.map